"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "InformationIcon", {
  enumerable: true,
  get: function get() {
    return _IconUiInformationCircle.default;
  }
});
Object.defineProperty(exports, "WarningIcon", {
  enumerable: true,
  get: function get() {
    return _IconUiWarningCircle.default;
  }
});
Object.defineProperty(exports, "ErrorIcon", {
  enumerable: true,
  get: function get() {
    return _IconUiWarningCircle.default;
  }
});
Object.defineProperty(exports, "SuccessIcon", {
  enumerable: true,
  get: function get() {
    return _IconUiTickCircle.default;
  }
});
Object.defineProperty(exports, "MorphIcon", {
  enumerable: true,
  get: function get() {
    return _MorphIcon.default;
  }
});

var _IconUiInformationCircle = _interopRequireDefault(require("../Icons/generated/IconUiInformationCircle"));

var _IconUiWarningCircle = _interopRequireDefault(require("../Icons/generated/IconUiWarningCircle"));

var _IconUiTickCircle = _interopRequireDefault(require("../Icons/generated/IconUiTickCircle"));

var _MorphIcon = _interopRequireDefault(require("../Icons/MorphIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }